export const viewport = function () {
    let e = window, a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return {width: e[a + 'Width'], height: e[a + 'Height']};
};

export const make_fixed = function (element, start_pos = 0, is_resize = false) {
    const $ = window.jQuery;

    if (!element.length) return;
    if (!element.closest('.stl-wrapper').length) element.wrap('<div class="stl-wrapper"></div>');
    let wpadminbar_height = $('#wpadminbar').length ? $('#wpadminbar').height() : 0;
    wpadminbar_height = viewport().width <= 600 ? 0 : wpadminbar_height;

    let parent = element.parent(),
        start = parent.offset().top - start_pos - wpadminbar_height;
    if ($(document).scrollTop() > start && (!element.hasClass('fixed') || is_resize)) {
        element.addClass('fixed');
        element.css({top: start_pos + wpadminbar_height + 'px'});
        parent.height(element.height());
    } else if ($(document).scrollTop() <= start && (element.hasClass('fixed') || is_resize)) {
        element.removeClass('fixed');
        element.css({top: 'auto'});
        parent.height('auto');
    }
};

export const scrollMe = function (elem) {
    let $ = window.jQuery;

    elem.on('click', function (e) {
        e.preventDefault();

        let section = $($(this).attr('href'));
        let delta = $(this).attr('delta');

        delta = (typeof delta !== typeof undefined && delta !== false) ? delta : 0;

        scrollTo(section, delta);
    });
};
export const scrollTo = function (section, delta = 0) {
    let $ = window.jQuery;

    if (section.length > 0) {
        let wpadminbar_height = $('#wpadminbar').length ? $('#wpadminbar').height() : 0;
        wpadminbar_height = viewport().width <= 600 ? 0 : wpadminbar_height;

        let header_height = $('#new-header').height(),
            start_pos = wpadminbar_height + header_height,
            start_to = section.offset().top - start_pos + 1 - delta;

        start_to = start_to < 0 ? 0 : start_to

        $('html,body').stop();
        $('html,body').animate({scrollTop: start_to}, 500, 'swing');
    }
};
